import { render, staticRenderFns } from "./BadManagerData.vue?vue&type=template&id=addb7b74&scoped=true"
import script from "./BadManagerData.vue?vue&type=script&lang=js"
export * from "./BadManagerData.vue?vue&type=script&lang=js"
import style0 from "./BadManagerData.vue?vue&type=style&index=0&id=addb7b74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addb7b74",
  null
  
)

export default component.exports